import { useGetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { IMPROVE_WRITING_ON_PASTE } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export const useGetImproveWritingPasteData = () => {
	const { data: onboardingStateData, loading } = useGetOnboardingState([
		IMPROVE_WRITING_ON_PASTE.FIRST_PASTE_VIEWED,
		IMPROVE_WRITING_ON_PASTE.SECOND_PASTE_VIEWED,
	]);

	// Only deserialize and return data when not loading and data is available
	if (loading || !onboardingStateData) {
		return {
			firstPasteViewed: undefined,
			secondPasteViewed: undefined,
		};
	}

	// Parse the onboarding state array directly
	const firstPasteState = onboardingStateData?.onboardingState?.find(
		(state) => state.key === IMPROVE_WRITING_ON_PASTE.FIRST_PASTE_VIEWED,
	);
	const secondPasteState = onboardingStateData?.onboardingState?.find(
		(state) => state.key === IMPROVE_WRITING_ON_PASTE.SECOND_PASTE_VIEWED,
	);
	const firstPasteViewed = firstPasteState?.value === 'true';
	const secondPasteViewed = secondPasteState?.value === 'true';

	return {
		firstPasteViewed,
		secondPasteViewed,
	};
};
